(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const initStickyHeaders = () => {
    document.querySelectorAll('[data-sp-header]').forEach((header) => {
      if (header.dataset.spStickyInitialized === 'true') return;
      header.dataset.spStickyInitialized = 'true';
      const section = header.closest('.shopify-section');
      const update = () => {
        const isScrolled = window.scrollY > 24;
        header.classList.toggle('is-scrolled', isScrolled);

        if (section && header.classList.contains('sp-header--sticky')) {
          section.style.minHeight = isScrolled ? `${header.offsetHeight}px` : '';
        }
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
    });
  };

  const initDrawers = () => {
    document.querySelectorAll('[data-sp-drawer-toggle]').forEach((toggle) => {
      if (toggle.dataset.spDrawerInitialized === 'true') return;
      toggle.dataset.spDrawerInitialized = 'true';
      const drawerId = toggle.getAttribute('aria-controls');
      const drawer = drawerId ? document.getElementById(drawerId) : null;
      if (!drawer) return;

      const mobileDrawerQuery = window.matchMedia('(max-width: 768px)');
      let closeTimer;

      const finishClose = () => {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      };

      const close = () => {
        toggle.setAttribute('aria-expanded', 'false');
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('sp-drawer-open');

        window.clearTimeout(closeTimer);
        if (mobileDrawerQuery.matches) {
          closeTimer = window.setTimeout(finishClose, 300);
        } else {
          finishClose();
        }
      };

      toggle.addEventListener('click', () => {
        const opening = toggle.getAttribute('aria-expanded') !== 'true';
        if (!opening) {
          close();
          return;
        }

        window.clearTimeout(closeTimer);
        toggle.setAttribute('aria-expanded', 'true');
        drawer.hidden = false;
        document.documentElement.classList.add('sp-drawer-open');

        if (mobileDrawerQuery.matches) {
          window.requestAnimationFrame(() => drawer.classList.add('is-open'));
        } else {
          drawer.classList.add('is-open');
        }
      });

      drawer.querySelectorAll('[data-sp-drawer-close]').forEach((button) => button.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !drawer.hidden) close();
      });
    });
  };

  const initDrawerAccordions = () => {
    document.querySelectorAll('[data-sp-drawer-accordion-toggle]').forEach((toggle) => {
      if (toggle.dataset.spDrawerAccordionInitialized === 'true') return;
      toggle.dataset.spDrawerAccordionInitialized = 'true';

      const setPanelState = (button, panel, opening) => {
        button.setAttribute('aria-expanded', String(opening));

        if (opening) {
          panel.hidden = false;
          window.requestAnimationFrame(() => panel.classList.add('is-open'));
          return;
        }

        panel.classList.remove('is-open');
        window.setTimeout(() => {
          if (!panel.classList.contains('is-open')) panel.hidden = true;
        }, 180);
      };

      toggle.addEventListener('click', () => {
        const drawer = toggle.closest('.sp-drawer');
        const panelId = toggle.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (!drawer || !panel) return;

        const opening = toggle.getAttribute('aria-expanded') !== 'true';
        if (opening) {
          drawer.querySelectorAll('[data-sp-drawer-accordion-toggle][aria-expanded="true"]').forEach((otherToggle) => {
            if (otherToggle === toggle) return;
            const otherPanelId = otherToggle.getAttribute('aria-controls');
            const otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
            if (otherPanel) setPanelState(otherToggle, otherPanel, false);
          });
        }

        setPanelState(toggle, panel, opening);
      });
    });
  };

  const initAccordions = () => {
    document.querySelectorAll('[data-sp-accordion-toggle]').forEach((toggle) => {
      if (toggle.dataset.spAccordionInitialized === 'true') return;
      toggle.dataset.spAccordionInitialized = 'true';
      toggle.addEventListener('click', () => {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) return;
        const opening = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(opening));
        panel.hidden = !opening;
      });
    });
  };

  const initialize = () => {
    initStickyHeaders();
    initDrawers();
    initDrawerAccordions();
    initAccordions();
  };

  onReady(initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
